import request from '@/utils/request' //引入封装好的 axios 请求
//银行上传
export function showFlag() {
    return request({
        url: '/api/homePage/status',
        method: 'post',
    })
}